"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StepLabelComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StepLabel = _interopRequireDefault(require("@mui/material/StepLabel"));
var _uiTheme = require("@kyruus/ui-theme");
const _overrides = theme => ({
  MuiStepIcon: {
    styleOverrides: {
      root: {
        color: theme.color_text_secondary,
        '&.Mui-active': {
          color: theme.color_button
        },
        '&.Mui-completed': {
          color: theme.color_button
        },
        '&.Mui-error': {
          color: theme.color_danger
        }
      }
    }
  },
  MuiStepLabel: {
    styleOverrides: {
      label: {
        color: theme.color_text_secondary,
        '&.Mui-active': {
          color: theme.color_text
        },
        '&.Mui-completed': {
          color: theme.color_text
        },
        '&.Mui-error': {
          color: theme.color_text
        }
      }
    }
  }
});
const StepLabelComponent = exports.StepLabelComponent = (0, _uiTheme.withMuiThemeAdapter)(_StepLabel.default, _overrides);
// This is silly, but it optimizes for developers.
// react-docgen can't find the propTypes unless it
// sees a component defininition.

const StepLabel_ = props => /*#__PURE__*/_react.default.createElement(StepLabelComponent, props);
StepLabel_.displayName = 'StepLabel';

// PropTypes taken from material-ui.
StepLabel_.propTypes = process.env.NODE_ENV !== 'production' ? {
  /**
   * @ignore
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes.default.bool,
  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: _propTypes.default.node,
  /**
   * Custom styles for component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * @ignore
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,
  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: _propTypes.default.bool,
  /**
   * Override the default icon.
   */
  icon: _propTypes.default.node,
  /**
   * @ignore
   */
  last: _propTypes.default.bool,
  /**
   * The optional node to display.
   */
  optional: _propTypes.default.node,
  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};
var _default = exports.default = StepLabel_;
StepLabel_.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "StepLabel"
};